import React from "react";

const Error = () => <div>Error. Plz press F5.</div>;

export default Error;
